import { useEffect, useState } from "react";

export const uri = "https://triad.africa";

async function getVideoDuration(url: string) {
  return new Promise((resolve) => {
    const video = document.createElement("video");
    video.src = url;
    video.preload = "metadata";
    console.log(video, "video");

    video.onloadedmetadata = () => {
      console.log(video.duration, "duration");
      resolve(video.duration);
    };

    video.onerror = () => {
      resolve(0); // Resolve with 0 if video metadata fails to load
    };
  });
}

function formatDuration(seconds: number) {
  const hour = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds / 60);
  const sec = Math.floor(seconds % 60);
  let formatted = "";
  if (hour > 0) formatted += `${hour}hr `;
  if (minutes > 0) formatted += `${minutes}min `;
  if (sec > 0) formatted += `${sec}s`;
  return formatted.trim() || "0s";
}

export const useGetVideoDuration = (videos: any[]) => {
  const [totalDuration, setTotalDuration] = useState<string>("Calculating...");

  useEffect(() => {
    async function calculateTotalDuration() {
      let total = 0;
      for (const video of videos) {
        const duration: any = await getVideoDuration(`${uri}${video.url}`);
        total += duration;
      }

      setTotalDuration(formatDuration(total));
    }

    if (videos?.length > 0) {
      calculateTotalDuration();
    }
  }, [videos]);

  return { totalDuration };
};

export const useGetSingleVideoDuration = (url: string) => {
  const [totalDuration, setTotalDuration] = useState("Calculating...");

  useEffect(() => {
    async function calculateTotalDuration() {
      const totals = await getVideoDuration(`${uri}${url}`);
      if (totals) {
        setTotalDuration(formatDuration(totals as number));
      }
    }
    calculateTotalDuration();
  }, [url]);

  return { totalDuration };
};
